import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule, ButtonModule, InputTextModule, SharedModule, TooltipModule, CheckboxModule, ChipsModule, MultiSelectModule, AutoCompleteModule,ProgressSpinnerModule} from "primeng/primeng";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { InputTrimModule } from "../../../directives/input-trim/input-trim.module";
import { GMapModule } from "primeng/components/gmap/gmap";
import { SibEmailComponent } from "./sib-email.component";

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        HttpModule,
        ButtonModule,
        SharedModule,
        InputTextModule,
        CheckboxModule,
        TooltipModule,
        InputTrimModule,
        GMapModule,
        ChipsModule,
        MultiSelectModule,
        AutoCompleteModule,
        ProgressSpinnerModule
    ],

    declarations: [
        SibEmailComponent,
    ],

    exports: [
        SibEmailComponent,
    ]
})

export class SibEmailModule { }
